function RecoverPasswordFailed(){
    return (
        <h1>q234</h1>
    )
}
export default RecoverPasswordFailed;